// extracted by mini-css-extract-plugin
export default {"resultPageContainer":"HomePage_resultPageContainer__efh59","isMobile":"HomePage_isMobile__8IqLO"};